import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import sanityClient from "../../client";
import { useHomeData } from "../../context/HomeContext";
import { urlFor } from "../../utils/imageUrl";

import "./index.css";

import IG_GRADIENT from "../../Assets/socialMediaIcons/IG_gradient.svg";
import SPOTIFY_GRADIENT from "../../Assets/socialMediaIcons/SPOTIFY_gradient.svg";
import YOUTUBE_GRADIENT from "../../Assets/socialMediaIcons/YOUTUBE_gradient.svg";

import HAMBURGER from "../../Assets/icons/burger.svg";
import CLOSE from "../../Assets/icons/close.svg";
import GRADIENT from "../../Assets/logos/gradient_logo.svg";

export const Header = () => {
  const [navData, setNavData] = useState([]);
  const [linkData, setLinkData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const { pathname } = useLocation();

  const homeData = useHomeData();
  const logoData = homeData?.hero || null;

  const toggleMobileMenu = () => {
    setShowDropdown(!showDropdown);
  };

  const fetchData = async () => {
    try {
      const query = `*[_type == 'header'][0] {
        navigation[] { _key, title, url },
        links[] { _key, url, icon { asset } }
      }`;
      const result = await sanityClient.fetch(query);
      setNavData(result.navigation);
      setLinkData(result.links);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <header className={`header ${pathname === "/" ? "normal" : "abnormal"}`}>
        <div className="dropdown">
          <img
            src={showDropdown ? CLOSE : HAMBURGER}
            alt={showDropdown ? "Close menu" : "Open menu"}
            onClick={() => toggleMobileMenu()}
          />
          <nav className={`dropdown-content ${showDropdown ? "show" : ""}`}>
            {navData.map((item) => {
              return (
                <a
                  key={item._key}
                  href={`${item.url ? item.url : "/" + item.title}`}
                >
                  {item.title}
                </a>
              );
            })}
          </nav>
        </div>
        {logoData && logoData.logo && pathname !== "/" && (
          <a href="/" className="logo-container">
            <img
              className="logo"
              src={urlFor(logoData.logo.asset._ref).width(800).url()}
              alt="Logo"
            />
            <img className="logo gradient" src={GRADIENT} alt="" />
          </a>
        )}
        <div className="links">
          {linkData.map((item) => {
            return (
              <a key={item._key} href={item.url}>
                <img
                  src={urlFor(item.icon.asset._ref).width(48).url()}
                  alt=""
                />
                {item.url.indexOf("instagram.com") > -1 && (
                  <img className="gradient" src={IG_GRADIENT} alt="Instagram" />
                )}
                {item.url.indexOf("spotify.com") > -1 && (
                  <img
                    className="gradient"
                    src={SPOTIFY_GRADIENT}
                    alt="Spotify"
                  />
                )}
                {item.url.indexOf("youtube.com") > -1 && (
                  <img
                    className="gradient"
                    src={YOUTUBE_GRADIENT}
                    alt="YouTube"
                  />
                )}
              </a>
            );
          })}
        </div>
      </header>
    </>
  );
};
